function setSearchResultTitle() {
  const urlParams = new URLSearchParams(window.location.search);
  const method = urlParams.get("method");
  const searchMethodElement = document.getElementById("search-method");

  if (!searchMethodElement) return;

  searchMethodElement.innerText = method === "shortcut" ? "포스트" : "검색 결과";
}

function setSelectedHeaderNavigationItem() {
  const path = window.location.pathname;
  const [firstPath, secondPath] = path.split("/").filter(Boolean);

  document.querySelectorAll(".site-header-posts-filter > *").forEach((element) => {
    element.classList.remove("selected-filter");
  });

  if (firstPath === "tag") {
    const element = document.querySelector(`.site-header-posts-filter > *[name="${secondPath}"]`);

    if (!element) return;

    element.classList.add("selected-filter");
  } else {
    const element = document.querySelector('.site-header-posts-filter > *[name="all"]');

    if (!element) return;

    element.classList.add("selected-filter");
  }
}

function setUtmContent() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmContent = urlParams.get("utm_content");

  if (utmContent) sessionStorage.setItem("utm_content", utmContent);

  const sessionUtmContent = sessionStorage.getItem("utm_content");
  const addUtmContentElements = document.querySelectorAll("a.add-utm-content");
  const addUtmContentWithSuffixElements = document.querySelectorAll("a.add-utm-content-with-suffix");

  addUtmContentElements.forEach((addUtmContentElement) => {
    const isFirstUtm = !addUtmContentElement.href.includes("?");

    addUtmContentElement.href = `${addUtmContentElement.href}${`${
      sessionUtmContent ? `${isFirstUtm ? "?" : "&"}utm_content=${sessionUtmContent}` : ""
    }`}`;
  });

  addUtmContentWithSuffixElements.forEach((addUtmContentWithSuffixElement) => {
    const isFirstUtm = !addUtmContentWithSuffixElement.href.includes("?");

    addUtmContentWithSuffixElement.href = `${addUtmContentWithSuffixElement.href}${
      isFirstUtm ? "?" : "&"
    }utm_content=success_${sessionUtmContent ?? "organic"}`;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setSearchResultTitle();
  setSelectedHeaderNavigationItem();
  setUtmContent();
});
